import { render, staticRenderFns } from "./ppob.vue?vue&type=template&id=19568ac4"
import script from "./ppob.vue?vue&type=script&lang=js"
export * from "./ppob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreView: require('/app/components/core/View.vue').default})
